import React from 'react'
import styles from './styles.module.css'

export const DefaultPagination = ({ current, total }: { current: number; total: number }) => (
  <div className={styles.defaultPagination}>
    {current} / {total}
  </div>
)
